import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateTimeFormatService {

  constructor() { }

  getUtcFromat(date): any {
    return date ? moment.utc(date).format('DD MMM YYYY hh:mm') + ' UTC' : date;
  }

  getUtcFromatWithoutText(date): any {
    return date ? moment.utc(date).format('DD MMM YYYY hh:mm') : date;
  }

  getDateFormat(date): any {
    return date ? moment.utc(date).format('DD MMM YYYY') : date;
  }
}
